"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKFLOW_DOC_SEGMENT = void 0;
exports.buildWorkflowDocId = buildWorkflowDocId;
exports.buildLocalWorkflowDocId = buildLocalWorkflowDocId;
exports.parseWorkflowDocId = parseWorkflowDocId;
exports.isLocalWorkflowDocId = isLocalWorkflowDocId;
exports.isWorkflowDocId = isWorkflowDocId;
/**
 * The draft of a workflow lives in one Yjs document. Its ID names the
 * workspace and the workflow: `db$<workspaceId>$workflow$<workflowId>`.
 * A client stores it without the workspace, as `db$workflow$<workflowId>`;
 * the ID converter of the sync layer adds and removes the workspace.
 *
 * Every reader and writer of the document builds and reads the ID here.
 */
exports.WORKFLOW_DOC_SEGMENT = 'workflow';
const DOC_PREFIX = 'db';
const SEPARATOR = '$';
function requireIdPart(name, value) {
    if (!value || value.includes(SEPARATOR)) {
        throw new Error(`A workflow document ID needs a ${name} without "${SEPARATOR}"`);
    }
    return value;
}
/** The ID the server stores the document under. */
function buildWorkflowDocId(workspaceId, workflowId) {
    return [
        DOC_PREFIX,
        requireIdPart('workspace ID', workspaceId),
        exports.WORKFLOW_DOC_SEGMENT,
        requireIdPart('workflow ID', workflowId),
    ].join(SEPARATOR);
}
/** The ID a client stores the document under. */
function buildLocalWorkflowDocId(workflowId) {
    return [
        DOC_PREFIX,
        exports.WORKFLOW_DOC_SEGMENT,
        requireIdPart('workflow ID', workflowId),
    ].join(SEPARATOR);
}
/** The workflow a server document ID of this workspace names, or null for any other document. */
function parseWorkflowDocId(docId, workspaceId) {
    const parts = docId.split(SEPARATOR);
    if (parts.length !== 4)
        return null;
    const [prefix, workspace, segment, workflowId] = parts;
    if (prefix !== DOC_PREFIX ||
        !workspaceId ||
        workspace !== workspaceId ||
        segment !== exports.WORKFLOW_DOC_SEGMENT ||
        !workflowId) {
        return null;
    }
    return { workflowId };
}
/** Whether a client document ID names a workflow document. */
function isLocalWorkflowDocId(docId) {
    const parts = docId.split(SEPARATOR);
    return (parts.length === 3 &&
        parts[0] === DOC_PREFIX &&
        parts[1] === exports.WORKFLOW_DOC_SEGMENT &&
        parts[2] !== '');
}
function isWorkflowDocId(docId, workspaceId) {
    return parseWorkflowDocId(docId, workspaceId) !== null;
}
